import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Input,
  InputSize,
  Select,
  Show
} from "shared/components";
import { FilterLines } from "untitledui-js-base";
import {
  Download02Icon,
  PlusSignIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { CreateLeadModal } from "shared/app/LeadsTableView/components/CreateLeadModal";

export const LeadsHeader = ({
  refetchLeads,
  search,
  setSearch,
  isCreateLeadModalOpen,
  hasHeaderTitle,
  setIsCreateLeadModalOpen
}: {
  refetchLeads: () => void;
  search: string;
  hasHeaderTitle?: boolean;
  setSearch: (search: string) => void;
  isCreateLeadModalOpen: boolean;
  setIsCreateLeadModalOpen: (isOpen: boolean) => void;
}) => {
  return (
    <header>
      <Show if={hasHeaderTitle}>
        <h1 className="text-2xl font-bold text-content-1000 mb-6">Leads</h1>
      </Show>
      <div className="mb-4">
        <div className="flex flex-wrap gap-3 items-center">
          <div className="max-w-[272px] w-full">
            <Input
              id="leads-search"
              size={InputSize.SM}
              hideOptional
              placeholder="Search leads"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="text-sm font-medium"
              legacyErrorMargins={false}
            />
          </div>
          <div className="flex flex-col justify-start items-start">
            <IconButton
              aria-label="Filters"
              variant={IconButtonVariant.BASE}
              size={IconButtonSize.SM}
              disabled
              onClick={() => alert("WIP")}
              Icon={FilterLines}
            />
          </div>
          <div className="flex flex-col w-[168px]">
            <Select
              id="assignee-select"
              size={InputSize.SM}
              hideOptional
              isDisabled
              placeholder="Assignee"
              value="any"
              onChange={() => null}
              options={[{ label: "Assignee", value: "Assignee" }]}
              className="text-sm font-medium"
              menuWidth="168px"
              legacyErrorMargins={false}
            />
          </div>
          <div className="ml-auto flex gap-2">
            <Button
              variant={ButtonVariant.BASE}
              size={ButtonSize.SM}
              disabled
              onClick={() => alert("WIP")}
              HugeIcon={Download02Icon}
            >
              Download CSV
            </Button>
            <Button
              variant={ButtonVariant.PRIMARY}
              size={ButtonSize.SM}
              HugeIcon={PlusSignIcon}
              onClick={() => setIsCreateLeadModalOpen(true)}
            >
              Create lead
            </Button>
          </div>
        </div>
      </div>

      <CreateLeadModal
        open={isCreateLeadModalOpen}
        refetchLeads={refetchLeads}
        onClose={() => setIsCreateLeadModalOpen(false)}
      />
    </header>
  );
};
